<div [formGroup]="subscriptionForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="externalId"
    placeholder="coreModuleModule.subscriptionDialogComponent.form.externalId.placeholder"
    label="coreModuleModule.subscriptionDialogComponent.form.externalId.label">
  </nx-edit-text-input>
  <nx-checkbox-text-input
    formControlName="active"
    [label]=" 'coreModuleModule.subscriptionDialogComponent.form.active.label' | translate ">
  </nx-checkbox-text-input>
  <nx-edit-text-input
    formControlName="url"
    placeholder="coreModuleModule.subscriptionDialogComponent.form.url.placeholder"
    label="coreModuleModule.subscriptionDialogComponent.form.url.label">
  </nx-edit-text-input>
  <nx-edit-multiselect-input
    [panelWidhtFull]="true"
    formControlName="eventTypes"
    placeholder="coreModuleModule.subscriptionDialogComponent.form.eventTypes.placeholder"
    label="coreModuleModule.subscriptionDialogComponent.form.eventTypes.label"
    [options]="eventTypes">
  </nx-edit-multiselect-input>
  <nx-edit-multi-key-value-input
    formControlName="customHtmlHeaders"
    placeholderKey="coreModuleModule.subscriptionDialogComponent.form.customHtmlHeaders.placeholderKey"
    placeholderValue="coreModuleModule.subscriptionDialogComponent.form.customHtmlHeaders.placeholderValue"
    label="coreModuleModule.subscriptionDialogComponent.form.customHtmlHeaders.label">
  </nx-edit-multi-key-value-input>
  <nx-edit-text-input
    *ngIf="!this.subscription"
    [maskContent]="true"
    formControlName="secret"
    label="coreModuleModule.subscriptionDialogComponent.form.secret.label">
  </nx-edit-text-input>
<div>